export default function () {
  const widgetName = "complianceBadges";
  const widgetOpts = complianceBadgesOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 5,
    maxItemsVisible: 5,

    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        customFooterButtons(widgetData);
      }
    },
  });

  function customFooterButtons(widgetData) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { Title, ImageWithPath, URL } = widgetData[x];
      let $badge = $(this);

      let hrefAttribute = URL !== null ? `href='${URL}'` : "";
      let classAttribute = URL === null ? "soc-badge void-link" : "soc-badge";

      let newElement = `
      <a ${hrefAttribute} class="${classAttribute}" aria-label="${Title}">
        <img src="${ImageWithPath}" alt="${Title}">
      </a>`;

      $badge.replaceWith(newElement);
    });
  }
}
